import React from 'react';
import './FormEntryMultilineTextbox.css';

export interface FormEntryMultilineTextboxProps {
  label?: string;
  name: string;
  value?: string;
  placeholder?: string;
  rows?: number;
  className?: string;
  id?: string;
  disabled?: boolean;
  textareaRef?: React.Ref<HTMLTextAreaElement>;
  autoFocus?: boolean;
  // Accept either a textarea-specific handler or the existing union handler used in the page
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
}

const FormEntryMultilineTextbox: React.FC<FormEntryMultilineTextboxProps> = ({
  label,
  name,
  value = '',
  placeholder = 'Placeholder...',
  rows = 4,
  className = '',
  id,
  disabled = false,
  textareaRef,
  onChange,
  autoFocus,
}) => {
  const wrapperClass = `form-entry-multiline ${className}`.trim();

  return (
    <div className={wrapperClass}>
      {label && (
        <label className="form-entry-multiline__label" htmlFor={id ?? name}>
          {label}
        </label>
      )}
      <textarea
        id={id ?? name}
        name={name}
        className="form-entry-multiline__textarea"
        placeholder={placeholder}
        value={value}
        rows={rows}
        onChange={onChange as React.ChangeEventHandler<HTMLTextAreaElement> | undefined}
        ref={textareaRef}
        disabled={disabled}
        autoFocus={autoFocus}
        aria-label={label ?? name}
      />
    </div>
  );
};

export default FormEntryMultilineTextbox;
